import { Inject, Injectable, inject } from '@angular/core';
import { ApmService } from '@elastic/apm-rum-angular';
import { AgentConfigOptions } from '@elastic/apm-rum';
import { APP_CONFIG, IAppSettings } from '../config/interfaces/iapp-settings.interface';

@Injectable({
	providedIn: 'root'
})
export class MonitoringService {
	_service = inject(ApmService);
	_monitoringSettings = inject<IAppSettings>(APP_CONFIG).monitoring;

	init(moduleName: string, globalLabels?: { [name: string]: string }): void {
		const globalSettings = this._monitoringSettings;
		if (globalSettings?.active === true) {
			const apm = this._service.init({
				...globalSettings,
				serviceName: moduleName
			});

			if (globalLabels) {
				apm.addLabels(globalLabels);
			}
		}
	}
}
